<script setup>
import { watch, onBeforeUnmount } from 'vue';
import { usePopupController } from '@/Composables/usePopupController';
const { isVisible, activeComponent, activeProps, dismissible, hidePopup  } = usePopupController();
const isTouch = ('ontouchstart' in window || navigator.maxTouchPoints > 0);

let previousBodyOverflow = '';
let previousHtmlOverflow = '';

function lockBackgroundScroll() {
    previousBodyOverflow = document.body.style.overflow;
    previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
}

function unlockBackgroundScroll() {
    document.body.style.overflow = previousBodyOverflow;
    document.documentElement.style.overflow = previousHtmlOverflow;
}

watch(isVisible, (visible) => {
    if (visible) {
        lockBackgroundScroll();
    } else {
        unlockBackgroundScroll();
    }
});

onBeforeUnmount(() => {
    if (isVisible.value) {
        unlockBackgroundScroll();
    }
});
</script>
<template>
    <div 
        v-if="isVisible"
        ref="popup"
        class="fixed inset-0 flex items-center justify-center bg-brand-dark-blue bg-opacity-75 z-10000 backdrop-blur-sm w-screen h-dvh"
    >
        <div
            class="w-fit h-auto bg-brand-cloud-100 rounded-lg p-4 sm:p-8 relative isolate overflow-y-auto overscroll-contain"
            :class="[
                {'max-w-[95%] max-h-[95%]': !isTouch},
                {'max-w-full max-h-full': isTouch},
            ]"
        >
            <div v-if="dismissible" class="absolute top-4 right-4 z-10 w-fit h-fit text-xl bg-white/50 hover:bg-white hover:text-platform-orange-dark transition-all rounded-lg p-2 flex items-center justify-center shadow-md cursor-pointer">
                <font-awesome-icon fixed-width icon="fa-light fa-xmark" @click.stop="hidePopup" />
            </div>
            <KeepAlive include="EditTextStyle">
                <component :is="activeComponent" v-bind="activeProps" />
            </KeepAlive>
        </div>
    </div>
</template>